import { z } from 'zod'

import { dateTimeFilterSchema, numberFilterSchema, stringFilterSchema, stringInFilterSchema } from './base_filters'

export const millsheetSubMaterialsFilterSchema = z.object({
  // ミルシートのフィルター
  manufacturerName: stringInFilterSchema.optional(),
  issuedDate: dateTimeFilterSchema.optional(),
  no: stringFilterSchema.optional(),
  buildingPart: stringInFilterSchema.optional(),
  submissionDate: dateTimeFilterSchema.optional(),
  deliveryDestination: stringFilterSchema.optional(),
  // ミルシート明細（機械式継手）の合計情報のフィルター
  totalQuantity: numberFilterSchema.optional(),
  // ミルシート明細（機械式継手）のフィルター
  productName: stringInFilterSchema.optional(),
  serialNumber: stringFilterSchema.optional(),
  quantity: numberFilterSchema.optional(),
})
export type MillsheetSubMaterialsFilter = z.infer<typeof millsheetSubMaterialsFilterSchema>

const sorterDirectionSchema = z.enum(['asc', 'desc'])
export const millsheetSubMaterialsSorterSchema = z.union([
  z.object({ manufacturerName: sorterDirectionSchema }),
  z.object({ issuedDate: sorterDirectionSchema }),
  z.object({ no: sorterDirectionSchema }),
  z.object({ buildingPart: sorterDirectionSchema }),
  z.object({ deliveryDestination: sorterDirectionSchema }),
  z.object({ totalQuantity: sorterDirectionSchema }),
  z.object({ productName: sorterDirectionSchema }),
  z.object({ serialNumber: sorterDirectionSchema }),
  z.object({ quantity: sorterDirectionSchema }),
])
export type MillsheetSubMaterialsSorter = z.infer<typeof millsheetSubMaterialsSorterSchema>

export const millsheetSubMaterialsSearchConditionSchema = z.object({
  filter: millsheetSubMaterialsFilterSchema.optional(),
  sorter: millsheetSubMaterialsSorterSchema.array().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
})
export type MillsheetSubMaterialsSearchCondition = z.infer<typeof millsheetSubMaterialsSearchConditionSchema>
